module.exports = __WEBPACK_EXTERNAL_MODULE_0__;


//////////////////
// WEBPACK FOOTER
// external {"root":"Vue","commonjs":"vue","commonjs2":"vue","amd":"vue"}
// module id = 0
// module chunks = 0 1